import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import PatientBanner from '../common/patientBanner';
import ProcedureList from './ProcedureList';
import ProcedureDetail from './ProcedureDetail';
import './styles.css';

class Service1259 extends Component {
  /**************
   * Properties *
   **************/
  state = {
    backgroundImage: require('../common/images/bkg.png'),
    bannerVisible: true
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1259">
        <ImageBackground id="background" />
        <PatientBanner visible={this.state.bannerVisible} />
        <Switch>
          <Route path="/scheduled_procedures/list" component={ProcedureList} />
          <Route path="/scheduled_procedures/details/:name/:page" component={ProcedureDetail} />
          <Route path="/scheduled_procedures" render={() => <Redirect to="/scheduled_procedures/list" />} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1259);
